var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout",class:{'offline-mode' : _vm.offline}},[_c('app-header'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"main"})],1),_c('fixed-steps'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }